import { Traducciones } from "@locale";

export const formatTraducir = (traducciones: Traducciones, claveTraducir: string, localeId: string = "es-AR") =>
    traducciones[claveTraducir] ? traducciones[claveTraducir][localeId] ?? claveTraducir : claveTraducir;
